import { render, staticRenderFns } from "./receita.vue?vue&type=template&id=fa276ed4&scoped=true"
import script from "./receita.vue?vue&type=script&lang=js"
export * from "./receita.vue?vue&type=script&lang=js"
import style0 from "./receita.vue?vue&type=style&index=0&id=fa276ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa276ed4",
  null
  
)

export default component.exports